import { notification } from "antd"
import { LoadingOutlined } from "@ant-design/icons"
import { isSessionExpired } from "../auth/AuthenticatedAxios"

export const messagePending = (key: string, head: string, text: string) => {
    notification.open({
        key: key,
        duration: 0,
        message: head,
        description: text,
        placement: "bottomLeft",
        icon: <LoadingOutlined style={{ color: "#ffb90f" }} />,
    })
}

export const messageSuccess = (key: string, head: string, text: string, time?: number) => {
    if (time && time !== 0) {
        notification.success({
            key: key,
            message: head,
            description: text,
            placement: "bottomLeft",
            duration: time,
        })
    } else {
        notification.success({
            key: key,
            message: head,
            description: text,
            placement: "bottomLeft",
        })
    }
}

export const messageInfo = (key: string, head: string, text: string, time?: number) => {
    if (time && time !== 0) {
        notification.info({
            key: key,
            message: head,
            description: text,
            placement: "bottomLeft",
            duration: time,
        })
    } else {
        notification.info({
            key: key,
            message: head,
            description: text,
            placement: "bottomLeft",
        })
    }
}

export const messageError = (key: string, head: string, text: string) => {
    // Folgefehler einer abgelaufenen Session nicht anzeigen (der Hinweis "Sitzung abgelaufen" genügt); offenen Lade-Toast schließen
    if (isSessionExpired()) {
        notification.destroy(key)
        return
    }
    notification.error({
        key: key,
        message: head,
        description: text,
        placement: "bottomLeft",
    })
}
